
import React from 'react';

const WhyChooseUsSection: React.FC = () => {
  const advantages = [
    {
      title: "Industry-Leading Expertise",
      description: "HP Inc Consulting Services has established itself as a premier provider of independent coating inspection services, with extensive experience across diverse industrial applications and coating systems.",
      icon: "ri-award-line"
    },
    {
      title: "NACE Certified Professional Staff",
      description: "Our team consists of highly trained and NACE certified coating inspectors with comprehensive knowledge of industry standards, specifications, and best practices for quality assurance.",
      icon: "ri-user-star-line"
    },
    {
      title: "Advanced Technology Integration",
      description: "We utilize state-of-the-art inspection equipment and digital documentation systems to provide accurate, real-time reporting and comprehensive project tracking capabilities.",
      icon: "ri-computer-line"
    },
    {
      title: "Comprehensive Quality Assurance",
      description: "Our systematic approach to coating inspection ensures compliance with project specifications while maintaining the highest standards of quality control throughout the application process.",
      icon: "ri-shield-check-line"
    },
    {
      title: "Nationwide Service Network",
      description: "With strategically located offices and NACE certified inspectors across the country, HP Inc Consulting Services provides consistent, reliable service delivery for projects of any scale or location.",
      icon: "ri-map-pin-line"
    },
    {
      title: "Proven Track Record",
      description: "Our extensive portfolio of successfully completed projects demonstrates our commitment to excellence and our ability to deliver superior coating inspection services across various industries.",
      icon: "ri-trophy-line"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Why Choose HP Inc Consulting Services for Coating Inspection?
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            HP Inc Consulting Services has pioneered advanced coating inspection methodologies that are now recognized as industry standards. Our comprehensive approach ensures optimal protection for your critical infrastructure investments.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => (
            <div key={index} className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${advantage.icon} text-blue-600 text-xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {advantage.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {advantage.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 bg-gray-50 p-8 rounded-lg">
          <p className="text-lg text-gray-700 leading-relaxed">
            Our comprehensive coating inspection experience encompasses work on all types of structural steel, storage tanks, marine vessels, bridges, industrial facilities, pipelines, chemical plants, and specialized infrastructure. Through our rigorous training programs and ongoing professional development, HP Inc Consulting Services maintains the most qualified team of NACE certified independent coating inspection professionals in the industry.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
